import type { Command } from 'commander';
import { buildAggregateJsonSchema } from '@wport/core';
import { printJson } from '../../../lib/output';

/**
 * 離線命令:純從 definition.ts SoT 推導 JSON Schema,不發請求、不需登入。
 * 沒有 --output table 分支 —— schema 本質是文件而非資料列表,永遠印 JSON(同 config get 慣例)。
 */
export function registerPersonalResumesSchema(parent: Command): void {
	parent
		.command('schema')
		.description('Print the resume aggregate JSON Schema (offline, no login required)')
		.option('--section <name>', 'print only the given section (e.g. education, work_experience)')
		.action((opts: { section?: string }) => {
			printJson(buildAggregateJsonSchema(opts.section));
		});
}
